import { PageMeta } from "../app/PageMeta";
import { ButtonLink } from "../components/ui/ButtonLink";
import { Section } from "../components/ui/Section";

export function NotFoundPage() {
  return (
    <>
      <PageMeta
        description="Return to the 7 Stones studio pages."
        path="/404"
        title="7 Stones | Route not found"
      />

      <Section
        eyebrow="404"
        intro="The route does not exist, but the studio shell remains intact."
        title="This page slipped out of orbit"
      >
        <div className="flex flex-wrap gap-3">
          <ButtonLink to="/">Return to the studio index</ButtonLink>
        </div>
      </Section>
    </>
  );
}
